module.exports = __webpack_public_path__ + "img/jcb.490ba6f0.png";